import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import CustomIcon from '../common/CustomIcon';
import { I18n } from 'react-redux-i18n-lite';

class ContentUploadBar extends React.Component {
  static propTypes = {
    isUploading: PropTypes.bool,
    percent: PropTypes.number
  };

  render() {
    const { isUploading, percent } = this.props;

    return isUploading ? (
      <div className="upload-content-container">
        <div className="progress-bar-container">
          <div className="progress-bar">
            <LinearProgress value={percent} variant="determinate" />
          </div>
        </div>
        <span>
          {percent}% {I18n.t('upload.uploaded')}
        </span>
      </div>
    ) : null;
  }
}
export default ContentUploadBar;
